import './App.css';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Router } from 'react-router-dom';
import { createTheme } from '@material-ui/core/styles';
import { createBrowserHistory } from "history";
import Route from './routes/app.routes';

const theme = createTheme({
  palette: {
    primary: { main: '#388e3c' },
    secondary: { main: '#388e3c' }
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#388e3c',
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: '#fff'
      },
      toolbarBtnSelected: {
        color: '#fff'
      }
    },
    MuiPickersDay: {
      daySelected: {
        color: '#fff'
      }
    },
    MuiPickersClockNumber: {
      clockNumberSelected: {
        color: '#fff'
      }
    }
  },
});

function App() {
  const history = createBrowserHistory();
  return (
    <MuiThemeProvider theme={theme}>
      <Router history={history}>
        <Route />
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
